"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const functions_1 = require("@/common/functions");
const string_utils_1 = require("@/common/string_utils");
const functions_2 = require("@/common/components/ProfileSettingDialog/functions");
function default_1({ ready, confirm }) {
    const [profiles, setProfiles] = (0, react_1.useState)([]);
    const getMultiProfileCookie = () => {
        const profilesCookie = (0, functions_1.getCookie)('profiles').replace(/\\054/g, ',');
        if (profilesCookie) {
            return JSON.parse(JSON.parse(profilesCookie));
        }
        else {
            return false;
        }
    };
    const noProfileCookieError = () => {
        confirm({
            description: (0, string_utils_1.logoutRequiredMsg)(),
            cancellationButtonProps: { style: { display: 'none' } },
            allowClose: false,
        })
            .then(functions_1.logout)
            .catch(() => { });
    };
    const fetchMultiProfiles = (attempts) => {
        var _a;
        if (attempts > 1) {
            noProfileCookieError();
        }
        else {
            const profilesArr = getMultiProfileCookie();
            if (!profilesArr || !((_a = profilesArr[0]) === null || _a === void 0 ? void 0 : _a.uid)) {
                (0, functions_2.getProfile)({
                    retryCount: 5,
                    onSuccess: () => setTimeout(() => fetchMultiProfiles(attempts + 1), 300),
                    onError: noProfileCookieError,
                });
            }
            else {
                setProfiles(profilesArr);
            }
        }
    };
    (0, react_1.useEffect)(() => {
        if (ready) {
            fetchMultiProfiles(0);
        }
    }, [ready]);
    return profiles;
}
exports.default = default_1;
